$(document).ready(function () {
  $('.bulknm-tab-item').click(function () {
    var parentItem = $(this).parents('.bulknm-item')
    var buyItem = parentItem.find('.bulknm-buy-item')
    var index = $(this).index();
    var itemImg = $(this).data('item-img')
    var itemAddCartUrl = $(this).data('item-add-cart-url')

    const prodItem = $(this).parents('.bulknm-item')
    prodItem.find('.bulknm-img img').attr('src', itemImg)
    prodItem.find('.bulknm-buy a').attr('href', itemAddCartUrl)

    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    // 购物车切换
    buyItem.hide(); // 首先隐藏所有项
    buyItem.eq(index).show(); // 显示对应索引的项
  })
})
